import { dropLast, last } from 'ramda'
import { useState } from 'react'
import { createModal, useModalize } from '@/components/modalize/mui'
import Context from './context'
import Home from './home'

const AddendumModal = ({
  initialView,
  addContractAddendums,
  standardTemplates,
  customTemplates,
  isAdmin,
  variables,
  planType,
  ModalTitle,
  ModalFooter,
  isOntario,
  isAlberta,
  ...props
}) => {
  const { close } = useModalize()
  const home = { component: Home }
  const [steps, setSteps] = useState([initialView || home])

  const [standardAddendums, setStandardAddendums] = useState(standardTemplates)
  const [standardSelected, setStandardSelected] = useState([])

  const [customAddendums, setCustomAddendums] = useState(customTemplates)
  const [customSelected, setCustomSelected] = useState([])

  const addStep = step => setSteps(arr => [...arr, step])
  const backStep = () => {
    const updatedSteps = dropLast(1, steps)
    return updatedSteps.length === 0 ? close() : setSteps(updatedSteps)
  }

  const currentStep = last(steps)
  const StepComponent = currentStep.component

  return (
    <Context.Provider
      value={{
        ModalTitle,
        ModalFooter,
        close,
        addStep,
        backStep,
        isAdmin,
        addContractAddendums,
        standardAddendums,
        setStandardAddendums,
        standardSelected,
        setStandardSelected,
        customAddendums,
        setCustomAddendums,
        customSelected,
        setCustomSelected,
        addendum: currentStep.addendum,
        addendumType: currentStep.addendumType,
        titleText: currentStep.titleText,
        footnote: currentStep.footnote,
        buttonText: currentStep.buttonText,
        isEditing: currentStep.isEditing,
        onSubmit: currentStep.onSubmit,
        onSubmitComplete: currentStep.onSubmitComplete,
        onDelete: currentStep.onDelete,
        onDeleteComplete: currentStep.onDeleteComplete,
        variables,
        planType,
        isOntario,
        isAlberta
      }}
    >
      <StepComponent />
    </Context.Provider>
  )
}

export const show = createModal(AddendumModal, {
  width: 'auto',
  maxWidth: '805px',
  sheet: true
})
